import { setupSlider } from '../components/slider'

const SELECTORS = Selectors({
  testimonialsSlider: 'testimonials-slider'
})

const $testimonialsSliders = document.querySelectorAll(SELECTORS.asClass('testimonialsSlider'))

const fn = {
  init: () => {
    $testimonialsSliders.forEach(($el) => {
      const opts = {
        fade: true,
        prevNextButtons: false,
        pageDots: false,
        pauseAutoPlayOnHover: true,
        wrapAround: false
      }

      setupSlider($el, opts)
    })
  }
}

export default {
  can: () => $testimonialsSliders.length,
  run: fn.init
}
